module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "PsUsername",
      "label": "Member Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PsEmail",
      "label": "E-Mail"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PsTelephone",
      "label": "Mobile"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PsSubject",
      "label": "Theme"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PsMessage",
      "label": "Leave Message"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.PsState == 0) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("回复")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('QuestionOne', {
    ref: "popForm",
    on: {
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-bar cfa"
  }, [_c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Inquiry Management")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Reply To Inquiry")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-73ef1702","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/cms/ProductQuestionManage.vue
// module id = 781
// module chunks = 1